module.exports = __webpack_public_path__ + "static/media/background_2.3cb0abcf.jpg";